import { Box, Container } from "@mui/material"

import CursorContextProvider from "./context/cursor/context"
import ThemeProvider from "./context/theme/context"

import Main from "./pages/main/main"
import Cursor from "./components/cursor/cursor"
import FloatingActionButton from "./utils/floatingActionButton"
import Navbar from "./components/navabar/navbar"

const App = ({ children }) => {
  return (
    <CursorContextProvider>
      <ThemeProvider>
        <Box bgcolor="#101010">
          <Container maxWidth="xl">
            <Cursor />

            <Navbar />

            <Main />

            {children}

            <FloatingActionButton />
          </Container>
        </Box>
      </ThemeProvider>
    </CursorContextProvider>
  )
}

export default App